import React, { useState } from "react";

const Experience = () => {
  const [expanded, setExpanded] = useState({
    connectingDots: false,
    gvmTechnologies: false,
  });

  const toggleExpand = (company) => {
    setExpanded((prev) => ({
      ...prev,
      [company]: !prev[company],
    }));
  };

  return (
    <div
      className="container-fluid d-flex align-items-center min-vh-100 bg-dark text-light"
      style={{ paddingTop: "50px" }}
    >
      <div className="row w-100">
        <h1 className="mb-5 text-center w-100">Professional Experience</h1>

        {/* Connecting Dots Experience */}
        <div className="col-md-12">
          <div className="d-flex justify-content-between mb-4">
            <div className="col-md-4 d-flex align-items-start">
              <strong>Const Company [ Connecting Dots ] =></strong>
            </div>
            <div className="col-md-8">
              <div>
                <strong>Designation:</strong> Web Developer
              </div>
              <div>
                <strong>Location:</strong> Pune, Maharashtra, India
              </div>
              <div>
                <strong>Date:</strong> April 2024 – Current
              </div>
              <ul className="mt-2">
                {expanded.connectingDots ? (
                  <>
                    <li>
                      <strong>•</strong> Full Stack Developer Role: Joined as a
                      Web Developer, specializing in both CMS management and
                      e-commerce projects, demonstrating versatility in
                      full-stack development.
                    </li>
                    <li>
                      <strong>•</strong> UI Development Expertise: Engaged in UI
                      development, crafting intuitive and responsive user
                      interfaces that enhance user experience and drive
                      engagement across various platforms.
                    </li>
                    <li>
                      <strong>•</strong> Collaboration with Digital Team:
                      Coordinated effectively with the digital marketing team to
                      implement SEO optimizations, ensuring that all projects
                      adhere to best practices for search engine visibility and
                      performance.
                    </li>
                    <li>
                      <strong>•</strong> Project Delivery: Successfully
                      delivered more than four projects on time, showcasing
                      strong project management skills and the ability to meet
                      client deadlines while maintaining high-quality standards.
                    </li>
                    <li>
                      <strong>•</strong> Comprehensive Project Involvement:
                      Contributed to all stages of project development, from
                      initial planning and design through to implementation and
                      optimization, ensuring seamless integration of frontend
                      and backend technologies.
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <strong>•</strong> Full Stack Developer Role: Joined as a
                      Web Developer, specializing in both CMS management and
                      e-commerce projects.
                    </li>
                    <li>
                      <strong>•</strong> UI Development Expertise: Engaged in UI
                      development, crafting intuitive and responsive user
                      interfaces.
                    </li>
                  </>
                )}
              </ul>
              <button
                onClick={() => toggleExpand("connectingDots")}
                className="btn btn-link text-primary"
              >
                {expanded.connectingDots ? "Show Less" : "Read More"}
              </button>
            </div>
          </div>
        </div>

        {/* GVM Technologies Experience */}
        <div className="col-md-12">
          <div className="d-flex justify-content-between mb-4">
            <div className="col-md-4 d-flex align-items-start">
              <strong>Const Company [ GVM Technologies ] =></strong>
            </div>
            <div className="col-md-8">
              <div>
                <strong>Designation:</strong> React JS Developer
              </div>
              <div>
                <strong>Location:</strong> Surat, Gujarat, India
              </div>
              <div>
                <strong>Date:</strong> September 2022 - January 2024
              </div>
              <ul className="mt-2">
                {expanded.gvmTechnologies ? (
                  <>
                    <li>
                      <strong>•</strong> Progressive Career Path: Joined GVM
                      Technologies as a JavaScript Developer, initially working
                      with Backbone.js.
                    </li>
                    <li>
                      <strong>•</strong> Expertise in React.js: Successfully
                      contributed to multiple projects, leveraging React.js to
                      create dynamic applications.
                    </li>
                    <li>
                      <strong>•</strong> Banking Domain Projects: Developed
                      secure applications that met stringent industry standards.
                    </li>
                    <li>
                      <strong>•</strong> Admin Panel Development: Led the
                      development of a comprehensive admin panel for Legal
                      Remit.
                    </li>
                    <li>
                      <strong>•</strong> Collaboration and Impact: Worked with
                      cross-functional teams for timely delivery of software
                      solutions.
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <strong>•</strong> Progressive Career Path: Joined GVM
                      Technologies as a JavaScript Developer.
                    </li>
                    <li>
                      <strong>•</strong> Expertise in React.js: Contributed to
                      multiple projects using React.js.
                    </li>
                  </>
                )}
              </ul>
              <button
                onClick={() => toggleExpand("gvmTechnologies")}
                className="btn btn-link text-primary"
              >
                {expanded.gvmTechnologies ? "Show Less" : "Read More"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
